import applicationResources from './base/en-TT';
import elementResources from 'element-ui/lib/locale/lang/en';

export default {
    ...applicationResources,
    ...elementResources
}